<mat-menu  [hasBackdrop]="true" class="action-menu" #themeMenu="matMenu" xPosition="before">
  @for (t of themes; track t) {
    <button mat-menu-item (click)="themeChange(t)">
      <!-- <mat-icon svgIcon="appIcon"></mat-icon> -->
      <span>{{ t }}</span>
    </button>
  }
</mat-menu>

<button
mat-menu-item
id="theme-switch"
  [matMenuTriggerFor]="themeMenu"
  aria-label="Switch theme"
>
  <mat-icon [svgIcon]="icons.PALETTE"></mat-icon>
</button>

